import React from "react";
import { useFetch } from "../../../../../hooks/Fetching";
import { useParams } from "react-router-dom";
import { LinearProgress } from "@mui/material";
import VaccinationTable from "../../../singleView/components/VaccinationTable";
import SimpleAlert from "../../../../../components/display/SimpleAlert";

export default function ListOfVaccines() {
  const { id } = useParams();
  const { data, isLoading, error } = useFetch(
    "/appointments/vaccines/",
    id,
    "appointment_vaccines" + id
  );
  if (isLoading) {
    return <LinearProgress />;
  } else if (error) {
    return (
      <SimpleAlert
        severity={"error"}
        message={"ErrorFetchingBiometricsList"}
        paper={true}
      />
    );
  }
  if (data?.length == 0 || !data) {
    return (
      <SimpleAlert
        severity={"info"}
        message={"NoVaccinesForThisAppointment"}
        paper={true}
      />
    );
  }

  return <VaccinationTable vaccinations={data} />;
}
